export enum SegmentEvents {
  AdminCustomFieldCreated = 'Admin: Custom Field Created',
  AdminCustomFieldEdited = 'Admin: Custom Field Edited',
  BoardCollaboratorsAdded = 'Boards: Collaborators Added',
  BoardsCollaboratorsRemoved = 'Boards: Collaborators Removed',
  BoardsCollectionAdded = 'Boards: Collection Added',
  BoardsCollectionDeleted = 'Boards: Delete Collection',
  BoardsCollectionEdited = 'Boards: Collection Edited',
  BoardsMomentCreated = 'Boards: Moment Created',
  BoardsStampedMomentCreated = 'Boards: Moment Created From Stamp',
  BoardsMomentDeleted = 'Boards: Moment Deleted',
  BoardsMomentDuplicated = 'Boards: Moment Duplicated',
  BoardsMomentEdited = 'Boards: Moment Edited',
  BoardsMomentRepositioned = 'Boards: Moment Repositioned',
  BoardsNavigateBoardsDirectory = 'Boards: Navigate to Boards List',
  BoardsNavigateBoardsSingleBoard = 'Boards: Navigate to Single Board',
  BoardsViewWorkflow = 'Boards: View Workflow',
  ChangeBoardPrivacy = 'Boards: Change Privacy',
  CopyBoardLink = 'Boards: Copy Link',
  CreateBoard = 'Boards: Create Board',
  DeleteBoard = 'Boards: Delete Board',
  DuplicateBoard = 'Boards: Duplicate Board',
  EditBoard = 'Boards: Edit Board',
  MomentAddedToBoard = 'Boards: Moment Added',
  MomentRemovedFromBoard = 'Boards: Moment Removed',
  ShareBoard = 'Boards: Share Board',
  SpreadsheetTextCellNavigate = 'Spreadsheet: Navigate from Text Cell',
  WorkflowCreateWorkflow = 'Workflow: Create Workflow',
  WorkflowCreateStage = 'Workflow: Create Stage',
  WorkflowCreateTask = 'Workflow: Create Task',
  WorkflowCreateApproval = 'Workflow: Create Approval',
  WorkflowCreatePauseAssignment = 'Workflow: Create Pause Assignment',
  WorkflowAssignUser = 'Workflow: Assign User',
  WorkflowUnassignUser = 'Workflow: Unassign User',
  WorkflowCompleteTask = 'Workflow: Complete Task',
  WorkflowApproveStage = 'Workflow: Approve Stage',
  WorkflowDenyStage = 'Workflow: Deny Stage',
  WorkflowResume = 'Workflow: Resume Paused Workflow',
}
